import React from 'react';
import {
  withSystem,
  Plugins,
  Atom,
  type AtomRenderProps,
  Types,
} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {extraAtomFields} from '@packages/shared/constants/Atoms';

import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';

const FormFileUploadLabel = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
    context,
  }: AtomRenderProps) => {
    const updatedClasses = classes.push('w-file-upload-label');
    const attrs = generateAttributes(attributes, updatedClasses);
    const forAttr = context.get('for') || attrs?.for;
    const finalAttrs = {
      ...attrs,
      for: forAttr,
    } as const;

    return (
      // Important for this to be a label because it is being styled as a button
      // and used instead of the <input type='file'>, which has been hidden instead
      // TODO: fix jsx-a11y lint error
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label {...finalAttrs}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </label>
    );
  }
);

const config = Atom.create({
  displayName: 'Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Link')),
  },
  showEmpty: false,
  constraints: {
    descendants: [
      {is: 'Link', rule: 'Forbid'},
      {is: 'List', rule: 'Forbid'},
      {is: 'DynamoList', rule: 'Forbid'},
      {is: 'RichText', rule: 'Forbid'},
      {is: 'NavbarWrapper', rule: 'Forbid'},
      {is: 'TabsWrapper', rule: 'Forbid'},
      {is: 'SliderWrapper', rule: 'Forbid'},
      {is: 'DropdownWrapper', rule: 'Forbid'},
      {is: 'LightboxWrapper', rule: 'Forbid'},
      {is: 'MapWidget', rule: 'Forbid'},
      {is: 'Facebook', rule: 'Forbid'},
      {is: 'Twitter', rule: 'Forbid'},
    ],
  },
  render: FormFileUploadLabel,
  dataType: withSystem(
    {private: true},
    TRecord(
      Types.deepMergeTypes(defaultIntegratedTypes, {
        attr: TRecord({
          for: TText,
          role: withSystem({defaultValue: 'button'}, TText),
          tabIndex: withSystem({defaultValue: '0'}, TText),
        }),
        children: TListOfElement,
      }),
      extraAtomFields
    )
  ),
  // Add the native ID path in attributes for Analyze tracking
  autoEngagementTrackingAttribute: true,
});

export default config;
